import RequestMaster from '../RequestMaster'

export default class RequestPedidoLibro extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/pedido-libro'
    }

    /**
     * Hace un create multiple
     *
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    createMultiple(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = "multiple"
        this.post(path, params, callback, callbackError, callbackFinally)
    }

    
    /**
     * Hace un edit multiple
     *
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    editMultiple(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = "multiple"
        this.put(path, params, callback, callbackError, callbackFinally)
    }


    /**
     * Hace un delete multiple
     *
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    deleteMultiple(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = "multiple"
        this.delete(path, params, callback, callbackError, callbackFinally)
    }
}
